import styles from "./404.module.css"
import SubmitButton from "../../components/Button/SubmitButton/SubmitButton";
import { useNavigate } from "react-router-dom";
import src404 from "../../assets/images/404.png"
import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/Navbar/NavbarMain/Navbar";
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";
import PageLayout from "../../components/Layout/PageLayout/PageLayout";
/**
* 404 Page.
* Shows up when user tries to access undefined route
* @returns TSX.Element
*/
const NotFound = () => {
    const { t } = useTranslation(); // Translation
    const navigate = useNavigate(); // Navigate

    return(
        <PageLayout
            pageClassName={styles.Page}
            headerClassName={styles.Header}
            headerInnerClassName={styles.Headergroup}
            contentClassName={styles.Content}
            footerClassName={styles.Footer}
            header={<Navbar />}
            footer={<Footer />}
        >
            <div className={styles.NotFound}>
                <div className={styles.NotFoundContent}>
                    <div className={styles.NotFoundText}>
                        <p className={styles.NotFoundTitle}><Trans i18nKey="404.title" components={{ 1: <span/> }} /></p>
                        <p className={styles.NotFoundDesc}>
                            <Trans i18nKey="404.text" components={{ 2: <a href="/contacts" /> }} />
                        </p>
                    </div>
                    <SubmitButton onClick={() => navigate("/home")} text={t("buttons.back_home")}/>
                </div>
                <div className={styles.NotFoundImage}>
                    <img src={src404} alt="" />
                </div>
            </div>
        </PageLayout>
    )
}
export default NotFound
